import type { FaireProductEntity } from "../../entity_types/product";

export const p_k96973wfkj: FaireProductEntity = {
  token: "p_k96973wfkj",
  type: "product",
  name: "Picnic Blanket, Tiled Produce",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/c864eba910274fa36323c082f3a17884900ba8cb86bd6a5081900b60c5544db5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/06242d46f54858c2c9987fadf1942295bef147ae64fef067cdd6e6c96a16f6a2.jpeg",
    "https://cdn.faire.com/fastly/88df1a5048604d2c77ad8dad47726399f98b5a074dd9e01c458f8c63994c28db.jpeg",
    "https://cdn.faire.com/fastly/fc8b07115773dd4b8a42058aff36b21c0592a47171043ca087951a3257e3071b.jpeg"
  ],
  priceDollars: 18.5,
  description: "Charcuterie and cute friends not included. This picnic blanket features a unique design on each side and an elastic loop for easy toting and storage. Lightweight, colorful, and ready for every sunny-day adventure.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• Double-sided blanket with two unique prints\n• Includes elastic loop for simple rolling, carrying, and storage\n• Lightweight, portable, and perfect for picnics, park days, beach hangs, and outdoor concerts\n• Durable and easy to clean\n• Designed in Bando’s signature cheerful, adventure-ready style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫\n\n• Gift shops and lifestyle boutiques\n• Outdoor, beach, and summer retailers\n• Picnickers, travelers, and weekend adventurers\n• Wholesale buyers seeking fun, functional outdoor accessories",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:40.999Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
